import { ComponentType } from 'react';

import Loadable from '@townsquare/loadable';
import { RouteContext } from '@townsquare/router/routing-types';

export const ChatLoadable: ComponentType<RouteContext> & LoadableExport.LoadableComponent =
	Loadable({
		loader: () => import(/* webpackChunkName: "chat-view" */ './ChatView'),
		loading: () => null,
	});
